import axios from 'axios';

export const updateUnishippersCredentials = (payload) => {
  return axios.post('/unishippers/updateSettings', payload);
};
